import React, { useState } from "react";
import PhoneNumberInput from "../../components/form/phone-number";
import { Button, notification, Spin } from "antd";
import DataProvider from "../../services";
import { NotificationType } from "../../types";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { convertToInternationalFormat } from "../../utils";
import { useAppStore } from "../../store";

export default function ActiveWithYelloCare() {
  const navigate = useNavigate();
  const { activateData } = useAppStore();
  const [loading, setLoading] = useState<boolean>(false);
  const [yolloCareData, setYolloCareData] = useState<any>({
    msisdn: "",
    yelloCareCode: "",
    name: "",
  });
  const [api, contextHolder] = notification.useNotification();

  const handleChange = (key: string, value: string) => {
    setYolloCareData({ ...yolloCareData, [key]: value });
  };

  const openNotificationWithIcon = (
    type: NotificationType,
    title: string,
    message: string
  ) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  const handleSubmit = async () => {
    if (!yolloCareData.msisdn) {
      openNotificationWithIcon("warning", "Warning", "Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        msisdn: convertToInternationalFormat(yolloCareData.msisdn),
        name: activateData?.name || yolloCareData.msisdn,
        yelloCareCode: convertToInternationalFormat(yolloCareData.msisdn),
      };

      await DataProvider.activateWithYelloCare(payload);
      openNotificationWithIcon("success", "Success", "Activated successfully");
      navigate("/main");

      // if (response.status === 200 || response.status === 201) {
      //   openNotificationWithIcon(
      //     "success",
      //     "Success",
      //     "Activated successfully"
      //   );
      //   navigate("/pick-plan");
      // } else {
      //   openNotificationWithIcon(
      //     "error",
      //     "Failed",
      //     "Failed to activate, Kindly check your yello care code."
      //   );
      // }
    } catch (error: any) {
      const errMsg: string =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message;
      openNotificationWithIcon(
        "error",
        "Failed",
        errMsg || "Failed to activate, Kindly check your yello care code."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col justify-start items-center py-12">
      <div className="mt-4 mb-5 md:w-[50%] w-full flex flex-col justify-center items-center">
        <div className="md:my-4 my-4 mx-5">
          <div className="flex flex-col justify-center items-start w-full ">
            <h1 className="text-2xl">MCare Subscription</h1>
            <p className="text-gray-400">Activate your Mcare subscription</p>
          </div>
          <PhoneNumberInput
            required
            title="Phone Number"
            value={yolloCareData.msisdn}
            onChangeText={(value: string) => handleChange("msisdn", value)}
            placeholder="0240005678"
            notes="This number will be your mcare subscription number. It is advisable to use a number with MoMo."
          />
          <Button
            type="primary"
            size="large"
            className="bg-[#1A94EC] w-full md:text-base text-sm mt-4"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              "Activate"
            )}
          </Button>
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
